import { render, staticRenderFns } from "./TheMagicFlute.vue?vue&type=template&id=0a5d6204&scoped=true&"
import script from "./TheMagicFlute.vue?vue&type=script&lang=ts&"
export * from "./TheMagicFlute.vue?vue&type=script&lang=ts&"
import style0 from "./TheMagicFlute.vue?vue&type=style&index=0&id=0a5d6204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d6204",
  null
  
)

export default component.exports